module.exports = __webpack_public_path__ + "img/Football-new.774f416.png";